<template>

    <section class="home" style="position:relative;">
        <section class="slider-hero">
            <div class="overlay"></div>
            <div class="hero-slider">
                <b-carousel id="carousel-1" v-model="slideItens" :interval="5000" fade controls indicators
                    img-width="1920" img-height="750" class="item work">
                    <!-- Slides with custom text -->
                    <b-carousel-slide v-for="slid in slider" :key="slid.institucionalId"
                        :img-src="$Url + slid.institucionalImg[0].urlImagem" class="img img2 d-flex align-items-center">
                    </b-carousel-slide>
                </b-carousel>
            </div>
        </section>

        <section class="ftco-section">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 text-center heading-section">
						<h2 class="mb-4">{{Titulo}}</h2>
					</div>
				</div>
				<div class="row no-gutters">
					<div v-for="item in itensHome" :key="item.institucionalId" class="col-lg-3 col-6 d-flex">
						<div class="services-2 noborder-left text-center">
							<div class="icon mt-2 mb-2 d-flex justify-content-center align-items-center">
								<a :href="item.referencia"><img :src="$Url + item.institucionalImg[0].urlImagem" style="width: 110px;" alt="" title="" /></a>
							</div>
							<div class="text media-body">
								<a :href="item.referencia"><h3>{{item.nome}}</h3></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

        <section class="ftco-intro ftco-no-pb img" :style="{backgroundImage: 'url(' + imgcall + ')',backgroundSize: 'cover'}">
			<div class="container">
				<div class="row justify-content-center">
					<div
						class="col-lg-9 col-md-8 d-flex align-items-center heading-section heading-section-white">
						<h2 class="mb-3 mb-md-0">{{TituloCall}}</h2>
					</div>
					<div class="col-lg-3 col-md-4">
						<p class="mb-0"><a :href="linkCall" target="_blank" class="btn btn-white py-3 px-4" style="border-radius: 25px;">{{textoBtn1Call}}
                            <img src="/images/whattsico.png" style="width: 20px;" /></a></p>
					</div>
				</div>
			</div>
		</section>

        <section class="ftco-section">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 text-center heading-section">
						<h2 class="mb-4">{{Titulo2}}</h2>
					</div>
				</div>
				<div class="row">
					<div v-for="prod in Produtos.slice(0,8)" :key="prod.produtoId" class="col-md-3 mt-2 mb-5">
						<a href="#"  @click="$redirect_reload('/produtoDetalhe/' + prod.produtoId + '/0/0/' + prod.nomeProduto.replaceAll(' ','-').replaceAll('/','').replaceAll('+',''))">
							<div v-if="prod.imagens!=null && prod.imagens!=''" class="project img d-flex justify-content-center align-items-center"
                            :style="{backgroundImage: 'url(' + $Url + prod.imagens[0].urlImg + ')', backgroundSize: 'contain', border:'1px solid #cccccc'}">
							</div>
						</a>
						<div class="text text-center">
							<a href="#" @click="$redirect_reload('/produtoDetalhe/' + prod.produtoId + '/0/0/' + prod.nomeProduto.replaceAll(' ','-').replaceAll('/','').replaceAll('+',''))" 
                            style="transition: .3s all ease; color: #000000;">
                                {{prod.nomeProduto}}</a>
						</div>
					</div>
                    <div class="col-md-12 mt-2 text-center" style="display: none;">
						<a href="#" @click="$redirect_reload('/Produtos')" class="btn py-2 px-3 btn-primary" style="border-radius: 25px;">
							<span>Ver mais produtos</span>
						</a>
					</div>
				</div>
			</div>
		</section>

        <section class="ftco-section" :style="{backgroundColor: Titulo3Cor}" v-if="Produtos2!=''">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-md-8 text-center heading-section">
						<h2 class="mb-4">{{Titulo3}}</h2>
					</div>
				</div>
				<div class="row">
					<div v-for="prod in Produtos2.slice(0,8)" :key="prod.produtoId" class="col-md-3 mt-2 mb-5">
						<a href="#"  @click="$redirect_reload('/produtoDetalhe/' + prod.produtoId + '/0/0/' + prod.nomeProduto.replaceAll(' ','-').replaceAll('/','').replaceAll('+',''))">
							<div v-if="prod.imagens!=null && prod.imagens!=''" class="project img d-flex justify-content-center align-items-center"
                            :style="{backgroundImage: 'url(' + $Url + prod.imagens[0].urlImg.replace(/ /g, '%20') + ')', backgroundSize: 'contain', border:'1px solid #cccccc'}">
							</div>
						</a>
						<div class="text text-center">
							<a href="#" @click="$redirect_reload('/produtoDetalhe/' + prod.produtoId + '/0/0/' + prod.nomeProduto.replaceAll(' ','-').replaceAll('/','').replaceAll('+',''))" 
                            style="transition: .3s all ease; color: #000000;">
                                {{prod.nomeProduto}}</a>
						</div>
					</div>
                    <div class="col-md-12 mt-2 text-center" style="display: none;">
						<a href="#" @click="$redirect_reload('/Produtos')" class="btn py-2 px-3 btn-primary" style="border-radius: 25px;">
							<span>Ver mais produtos</span>
						</a>
					</div>
				</div>
			</div>
		</section>
        <!-- aqui testemunhos-->
        <Depoimentos />
        <section class="ftco-intro ftco-no-pb img" :style="{backgroundImage: 'url(' + imgcallavalia + ')',backgroundSize: 'cover'}">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-lg-8 col-md-4">
						<p class="mb-0">
                        <router-link to="/avaliacao" class="btn btn-white py-3 px-4" style="border-radius: 25px;font-size: 25px;">{{TextoCallAvaliacao}}
                        </router-link></p>
					</div>
				</div>
			</div>
		</section>
    </section>

</template>

<script>
import { VMoney } from 'v-money'
import moment from 'moment'
import Depoimentos from '../shared/Depoimentos.vue'

export default {
    components: {
        Depoimentos,
    },
    data() {
        return {
            ItensHome: [],
            ItemHome: {},
         
            slide: 0,
            sliding: null,
            Retorno:[],
            Titulo: '',
            Titulo2:'',
            Titulo3:'',
            Titulo3Cor:'',
            Produtos2:[],
          
            itensHome: [],

            callaction:[],
            TituloCall:'',
            textoBtn1Call:'',
            linkCall:'',
            imgcall:'',

            money: {
                decimal: ',',
                thousands: '.',
                precision: 2,
                masked: true
            },
            showModal: false,
            textomodal: [],
            tituloModal: '',
            textoModal: '',
            textoBtnmodal: '',
            textobusca: '',
            slideItens: '',
            slider: [],
            numeros: [],
            Produtos:[],
            callactionavalia:[],
            TextoCallAvaliacao:'',
            imgcallavalia:'',
        }
    },
    directives: { money: VMoney },
    methods: {
        currentDateTime(vdate) {
            return moment(vdate).format('DD/MM/YYYY')
        },
        ValidaBusca() {
            if (this.textobusca != '') {
                this.$redirect("/produtosbusca/" + this.textobusca);
            }
            else {
                this.$mensagem_normal("Digite uma palavra-chave e clique na lupa para pesquisar.");
            }

        },
        initCarousel() {
            this.sliding = true
        },
        endSlide() {
            this.sliding = false
        },
    },
    created() {

        this.$http
            .get(this.$apiUrl + "/institucional/telas/slider")
            .then((res) => res.json())
            .then((retornoAPI) => {
                this.slider = retornoAPI.filter(x => x.visivel).sort(function (a, b) {
                    if (a.ordem > b.ordem) {
                        return 1;
                    }
                    if (a.ordem < b.ordem) {
                        return -1;
                    }
                    return 0;
                }).reverse();
            });


        this.$http
            .get(this.$apiUrl + "/institucional/telas/títuloitens")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.Retorno = tiu2;

                if (this.Retorno != null) {
                    this.Titulo = this.Retorno[0].nome;
                    this.Titulo2 = this.Retorno[0].referencia;
                    this.Titulo3 = this.Retorno[0].campoExtra1;
                    this.Titulo3Cor = this.Retorno[0].cor1;
                }

            });

        this.$http
            .get(this.$apiUrl + "/institucional/telas/itensHome")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.itensHome = tiu2.filter(x=> x.visivel).sort(function (a, b) {
                    if (a.ordem > b.ordem) {
                        return 1;
                    }
                    if (a.ordem < b.ordem) {
                        return -1;
                    }
                    return 0;
                });
            });

            this.$http
            .get(this.$apiUrl + "/institucional/telas/callaction")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.callaction = tiu2;

                if (this.callaction != null) {
                    this.TituloCall = this.callaction[0].nome;
                    this.textoBtn1Call = this.callaction[0].textoBtn1
                    this.linkCall = this.callaction[0].linkBtn1
                    if (this.callaction[0].institucionalImg!=''){
                        this.imgcall = this.$Url + this.callaction[0].institucionalImg[0].urlImagem
                    }
                }

            });

            this.$http
            .get(this.$apiUrl + "/institucional/telas/chamadaavaliações")
            .then((res2) => res2.json())
            .then((tiu2) => {
                this.callactionavalia = tiu2;

                if (this.callactionavalia != null) {
                    this.TextoCallAvaliacao = this.callactionavalia[0].nome;
                    if (this.callactionavalia[0].institucionalImg!=''){
                        this.imgcallavalia = this.$Url + this.callactionavalia[0].institucionalImg[0].urlImagem
                    }
                }

            });


        this.$http
            .get(this.$apiUrl + "/produto")
            .then((res) => res.json())
            .then((retornoAPI) => {
                this.Produtos = retornoAPI.filter((x) => x.visivel && x.destaque &&x.imagens!=null && x.imagens!='')

                this.Produtos.sort(function () {
                    return .5 - Math.random();
                });
            });

        this.$http
            .get(this.$apiUrl + "/produto")
            .then((res) => res.json())
            .then((retornoAPI) => {
                this.Produtos2 = retornoAPI.filter((x) => x.visivel && x.promocao &&x.imagens!=null && x.imagens!='')

                this.Produtos2.sort(function () {
                    return .5 - Math.random();
                });
            });

    },
    mounted() {

    },
}

</script>

<style>
@import '/css/produtos.css';

.carousel-caption {
    position: absolute !important;
    right: 15% !important;
    bottom: 11.25rem !important;
    left: 10% !important;
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem;
    color: #fff;
    text-align: left !important;
}

.bg-color {
    background-color: #993366;
}

.imagem_produto {
    max-height: 250px;
}

.product_item {
    width: 100%;
    transition: all .2s ease-in;
    background-color: transparent;
}

.vfigure {
    position: absolute;
    float: left;
    top: 20px;
    height: 40px;
    z-index: 999;
    text-align: center;
}

.vfigcaption {
    font-size: 12px;
    left: 0px;
    top: 17px;
    color: #000000;
    width: 50px;
    position: absolute;
}

.vfigcaption2 {
    font-size: 12px;
    left: 0px;
    top: 17px;
    color: #000000;
    width: 50px;
    position: absolute;
}

.vfigure2 {
    position: absolute;
    float: left;
    top: 20px;
    height: 40px;
    z-index: 999;
    text-align: center;
}




/********************
    Responsive
    ********************/

/* Smartphones */
@media (max-width:767px) {
    .product_item {
        left: 0px;
    }

    .vfigure {
        position: absolute;
        float: left;
        top: 65px;
        height: 40px;
        z-index: 999;
        text-align: center;
    }

    .vfigcaption {
        font-size: 12px;
        left: 0px;
        top: 17px;
        color: #000000;
        width: 50px;
        position: absolute;
    }

    .peq {
        font-size: 9px;
        left: 0px;
        top: 10px;
        color: #000000;
        width: 36px;
        position: absolute;
    }

    .imgcelet {
        width: 35px;
    }

    .vfigure2 {
        position: absolute;
        float: left;
        top: 65px;
        height: 40px;
        z-index: 999;
        left: 30px;
    }


    .vfigcaption2 {
        font-size: 12px;
        left: 0px;
        top: 17px;
        color: #000000;
        width: 50px;
        position: absolute;
    }

    .new_arrivals_title {
        position: absolute;
        left: 0;
        top: 20px;
        font-size: 24px;
        font-weight: 500;
        margin-bottom: -29px;
    }
}

/* Tudo, menos desktop */
@media (max-width:1199px) {
    .product_item {
        height: min-content;
        padding-top: 60px;
        padding-bottom: 40px;
    }

    .product_price {
        margin-top: 0px;
    }
}

/* Desktop + Notbooks */
@media (min-width:1200px) {
    .product_item_alt {
        min-height: 240px;
    }
}

p {
    margin-top: 0;
    margin-bottom: 0rem !important;
}
</style>